import { Container } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import useModal from '../../../hooks/useModal';
import PensionVerificationLetter from './pensionVerificationLetter';
import SuccessVerificationModal from './successVerificationLetterModal';

const PensionVerificationLetterModalDemo = () => {
  const [showModal, handleShowModal, handleCloseModal] = useModal();
  const [showSuccessModal, handleShowSuccessModal, handleCloseSuccessModal] =
    useModal();

  return (
    <Container>
      <Container className="mt-10">
        <h4>Pension Verification Letter Modal</h4>
        <Button onClick={handleShowModal}>
          Open Verification Letter Modal
        </Button>
        <PensionVerificationLetter
          showModal={showModal}
          handleCloseModal={handleCloseModal}
          handleConfirm={handleCloseModal}
        />
        <div className={'pt-10'}>
          <Button onClick={handleShowSuccessModal}>Open Success Modal</Button>
          <SuccessVerificationModal
            showSuccessVerificationModal={showSuccessModal}
            handleCloseSuccessVerificationModal={handleCloseSuccessModal}
          />
        </div>
      </Container>
    </Container>
  );
};

export default PensionVerificationLetterModalDemo;
